import type { JSONSchema7 } from 'json-schema';

import type { DeepReadonly } from './types';

// IBM's suggested way to run these models is through hugging face. The way these are set up in HuggingFace do not
// lend well to the parameter pattern that we're using elsewhere, so leaving suggested params blank. Users will
// still be able to add parameters via the custom parameters in the UI
export const watsonJsonSchema = {
  properties: {},
} as const;

export const watsonSchemaProperties: DeepReadonly<JSONSchema7> = watsonJsonSchema;

export const retrieveWatsonParameters = (): string[] => Object.keys(watsonJsonSchema.properties);
